<app-form>
  <ng-container *ngIf="!showCodeView">
    <app-user-confirmation></app-user-confirmation>
  </ng-container>

  <ng-container *ngIf="showCodeView">
    <app-code-confirmation-form></app-code-confirmation-form>
  </ng-container>
</app-form>